import { useParams } from 'react-router-dom'
import { BlogArticle, blogPostBySlug } from '@kkf/design'
import { POSTS } from '../data/blog'
import { SITE } from '../data/seo'

/**
 * One post, resolved from `/blog/:slug`.
 *
 * The page is `@kkf/design`'s `BlogArticle`, shared with the other three public sites. This
 * file is the lookup, and the site tree root that lets a slug this site does not carry mark
 * itself `noindex`.
 *
 * **An unknown slug renders the article's not-found state, and here that is the ordinary
 * case rather than a defensive branch.** This site carries a subset of one library, so a
 * link to a post filed under another venture really will arrive — and serving the first
 * post instead would put somebody else's article under the address that was typed.
 */
export function BlogDetailsPage() {
  const { slug } = useParams()
  return <BlogArticle posts={POSTS} post={blogPostBySlug(POSTS, slug)} site={SITE} />
}
